export default function throttle(fn: (...args: any[]) => any, delay: number) {
  let timerId: number
  let executedTime = 0
  const execute = (...args: any[]) => {
    fn(...args)
    executedTime = performance.now()
  }

  return (...args: any[]) => {
    timerId ? clearTimeout(timerId) : execute(...args)
    performance.now() - executedTime > delay
      ? execute(...args)
      : (timerId = window.setTimeout(() => execute(...args), delay))
  }
}
